import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const Header = () => {
  const { currentUser, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="bg-navy-900 shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            {/* Icon mark */}
            <div className="w-10 h-10 rounded-lg overflow-hidden shadow-glow bg-navy-800 border border-navy-700">
              <img
                src={process.env.PUBLIC_URL + '/favicon.svg'}
                alt="SwingTraderEdge"
                className="w-10 h-10"
              />
            </div>
            <div>
              <span className="text-xl font-bold text-white tracking-tight">
                SwingTrader<span className="text-brand-400">Edge</span>
              </span>
              <span className="hidden sm:block text-xs text-navy-400 -mt-1">AI-Powered Signal Intelligence</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-navy-300 hover:text-white transition-colors text-sm font-medium">
              Home
            </Link>
            
            {currentUser ? (
              <>
                <Link to="/dashboard" className="text-navy-300 hover:text-white transition-colors text-sm font-medium">
                  Dashboard
                </Link>
                
                {isAdmin && (
                  <Link to="/admin" className="text-navy-300 hover:text-white transition-colors text-sm font-medium">
                    Admin
                  </Link>
                )}
                
                <button 
                  onClick={handleLogout}
                  className="text-navy-300 hover:text-white transition-colors text-sm font-medium"
                >
                  Logout
                </button>
                
                <div className="flex items-center ml-4 pl-4 border-l border-navy-700">
                  <img 
                    src={currentUser.photoURL || 'https://via.placeholder.com/32'} 
                    alt="Profile" 
                    className="w-8 h-8 rounded-full ring-2 ring-brand-500 mr-2"
                  />
                  <span className="text-sm text-navy-200">
                    {currentUser.displayName || currentUser.email}
                  </span>
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-3">
                <Link 
                  to="/login" 
                  className="text-navy-300 hover:text-white transition-colors text-sm font-medium"
                >
                  Log In
                </Link>
                <Link 
                  to="/login" 
                  className="ste-btn-primary text-sm !py-2 !px-4"
                >
                  Get Started Free
                </Link>
              </div>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-navy-300 hover:text-white focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pt-4 border-t border-navy-700">
            <ul className="space-y-4">
              <li>
                <Link to="/" className="block text-navy-300 hover:text-white" onClick={() => setMobileMenuOpen(false)}>
                  Home
                </Link>
              </li>
              
              {currentUser ? (
                <>
                  <li>
                    <Link to="/dashboard" className="block text-navy-300 hover:text-white" onClick={() => setMobileMenuOpen(false)}>
                      Dashboard
                    </Link>
                  </li>
                  {isAdmin && (
                    <li>
                      <Link to="/admin" className="block text-navy-300 hover:text-white" onClick={() => setMobileMenuOpen(false)}>
                        Admin
                      </Link>
                    </li>
                  )}
                  <li>
                    <button onClick={() => { handleLogout(); setMobileMenuOpen(false); }} className="block text-navy-300 hover:text-white">
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                <li>
                  <Link to="/login" className="block ste-btn-primary text-center text-sm" onClick={() => setMobileMenuOpen(false)}>
                    Get Started Free
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
